<template>
  <el-select class="status" v-model="filter" multiple placeholder="Statuts" size="mini" :data-show="selecteds.length > 1">
    <el-option
      v-for="item in selecteds"
      :key="item.id"
      :label="item.name"
      :value="item.name"
      :data-state="state(item)">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'SportGamesFiltersStatus',
  props: {
    games: Array
  },
  data () {
    return {
      statuses: []
    }
  },
  computed: {
    all () { return this.$store.getters['Sport/GameStatus/list'] },
    selectedId () { return [...new Set(this.games.map(item => item.statusId))] },
    selecteds () { return this.all.filter(item => this.selectedId.indexOf(item.id) > -1) },
    filter: {
      get () {
        return this.all.filter(item => this.statuses.indexOf(item.id) > -1).map(item => item.name)
      },
      set (statuses) {
        const list = []
        for (const i in statuses) {
          const status = this.all.find(item => item.name === statuses[i])
          list.push(status.id)
        }
        this.statuses = list
        this.$emit('change', list)
      }
    }
  },
  methods: {
    state (status) { return status.live ? 1 : (status.stopped ? 2 : (status.ended ? 3 : 0)) }
  }
}
</script>

<style scoped>
  .status{
    margin:0 10px 10px 10px;
    flex: 0 0 auto;
    transition: opacity 0.3s ease;
  }
  .status:not([data-show="true"]){
    opacity: 0;
  }
  [data-state="0"]{
    color:var(--color-upcoming)
  }
  [data-state="1"]{
    color:var(--color-live)
  }
  [data-state="2"]{
    color:var(--color-stopped)
  }
  [data-state="3"]{
    color:var(--color-ended)
  }

</style>
